<template>
  <div

    class="userMenu__wrapper"
  >
    <a
      href="mailto:help@soobahkdoinstitute.com"
      class="userMenu__button userMenu__button--help"
    >
      <span class="uk-icon-envelope-o" /> Need Tech Support?
    </a>

    <slot />

    <div
      v-if="authenticated"
      class="userMenu__group"
    >
      <div class="userMenu__text">
        Logged in to the Soo Bahk Do Institute as
      </div>
      <div
        v-click-outside="onClickOutside"
        class="userMenu"
        :class="{'userMenu--open': showDropdown}"
        @mouseleave="showDropdown = false"
      >
        <div
          class="userMenu__button userMenu__button--profile"
          @click="showDropdown = !showDropdown"
          @mouseenter="showDropdown = true"
        >
          <img
            v-if="user.data._links.profile_picture"
            :src="user.data._links.profile_picture"
            class="userMenu__picture"
          > {{ user.getFullName() }}
        </div>
        <ul
          v-if="showDropdown"
          class="userMenu__items"
        >
          <li class="userMenu__item">
            <a
              href="#"
              @click.prevent="logout"
            >Logout</a>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-else
      class="userMenu__group"
    >
      <div class="userMenu__text userMenu__text--blank">
        <span class="uk-icon-exclamation-circle userMenu__icon" /> You are not logged in to this event.
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop} from "vue-property-decorator";
import UserModel from "../../models/UserModel";

Vue.directive('click-outside', {
  bind: function (el: any, binding, vnode: any) {
    el.clickOutsideEvent = function (event: Event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el: any) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

@Component({
  directives: {

  }
})
export default class Menu extends Vue {

  @Prop({default: false}) hideIfGuest!: boolean;
  @Prop({default: false}) compact!: boolean;

  showDropdown = false;

  get user(): UserModel {
    return this.$store.getters['context/user'];
  }

  get authenticated(): boolean {
    return this.user.isAuthenticated();
  }

  logout(): void {
    this.showDropdown = false;
    this.$store.dispatch('context/logout');
  }

  onClickOutside(): void {
    this.showDropdown = false;
  }

}
</script>

<style scoped>
.userMenu {
  display: inline-block;
  position: relative;
}
.userMenu__wrapper {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}
.userMenu__group {
  display: flex;
}
.userMenu__items {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  list-style: none;
  z-index: 10;
  text-align: left;
}
.userMenu__item {
  display: flex;
}
.userMenu__item > * {
  background: #e2e2e2;
  flex: 1;
  padding: 0.5em;
}
.userMenu--open .userMenu__button--profile {
  border-bottom-right-radius: 0;
}
.userMenu__text {
  align-self: stretch;
  display: flex;
  align-items: center;
  background: #000;
  padding: 0.5em;
  color: #fff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.userMenu__text:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.userMenu__text--blank {
  background-color: #fff;
  color: #000;
}
.userMenu__button {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: 0.5em;
  cursor: pointer;
  border-radius: 5px;
  background-color: #103310;
  color: #fff;
  transition: background-color 300ms ease-in-out;
}
.userMenu--open .userMenu__button, .userMenu__button:hover {
  text-decoration: none;
  background: #468646;
}
.userMenu__button [class*="uk-icon-"] {
  margin-right: 0.5em;
}
.userMenu__button--profile {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.userMenu__picture {
  height: 20px;
  margin-right: 0.5em;
  border-radius: 1em;
  border: 2px solid #fff;
}
.userMenu__icon {
  font-size: 2em;
  margin-right: 5px;
}
@media only screen and (max-width: 480px) {
  .userMenu__wrapper {
    display: block;
    line-height: 2em;
  }
  .userMenu__wrapper > * {
    margin-bottom: 1em;
  }
  .userMenu__items {
    left: auto;
  }
  .userMenu__item > * {
    min-width: 50vw;
    padding: 1em;
  }
}

</style>
